import { render } from "./RichTextEditor.vue?vue&type=template&id=5fe548e6&scoped=true"
import script from "./RichTextEditor.vue?vue&type=script&lang=js"
export * from "./RichTextEditor.vue?vue&type=script&lang=js"

import "./RichTextEditor.vue?vue&type=style&index=0&id=5fe548e6&lang=scss&scoped=true"
import "./RichTextEditor.vue?vue&type=style&index=1&id=5fe548e6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe548e6"]])

export default __exports__